export default __webpack_public_path__ + "images/Coronal_View_of_the_Spine.c0fd159fea741a7a3997ebd2cdb31699.png";